import { render, staticRenderFns } from "./IconChevronLeft.vue?vue&type=template&id=401d4800&scoped=true&"
import script from "./IconChevronLeft.vue?vue&type=script&lang=js&"
export * from "./IconChevronLeft.vue?vue&type=script&lang=js&"
import style0 from "./IconChevronLeft.vue?vue&type=style&index=0&id=401d4800&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401d4800",
  null
  
)

export default component.exports